<template>
  <div>
    <el-form :inline="true" style="margin-bottom: 20px;">
      <el-form-item>
        <el-input
          v-model="searchForm.journeyTitle"
          placeholder="地图名称"
          clearable
          style="width: 200px"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.projectName"
          placeholder="地图所属项目"
          clearable
          style="width: 200px"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.createBy"
          placeholder="创建人"
          clearable
          style="width: 200px"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="createTimeRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="创建时间开始"
          end-placeholder="创建时间结束">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="updateTimeRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="最后修改时间开始"
          end-placeholder="最后修改时间结束">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="getJourneyMapList">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe>
      <el-table-column
        prop="journeyTitle"
        label="地图名称"
        width="200">
      </el-table-column>
      <el-table-column
        prop="journeyDescribe"
        label="地图描述"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="projectName"
        label="地图所属项目"
        width="200">
      </el-table-column>
      <el-table-column
        prop="createBy"
        label="创建人"
        width="150">
      </el-table-column>
      <el-table-column
        prop="createTime"
        width="180"
        label="创建时间">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        width="180"
        label="最后修改时间">
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.current"
      :page-size="page.size"
      :total="page.total"
      style="margin-top: 20px; float: right;">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "ContentJourneyMap",
  data() {
    return {
      searchForm: {},
      createTimeRange: [],
      updateTimeRange: [],
      tableData: [],
      page: {
        total: 0,
        size: 10,
        current: 1,
      }
    }
  },
  created() {
    this.getJourneyMapList()
  },
  methods: {
    handleSizeChange(val) {
      this.page.size = val
      this.getJourneyMapList()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.getJourneyMapList()
    },
    resetSearch() {
      this.searchForm = {}
      this.createTimeRange = []
      this.updateTimeRange = []
      this.page.current = 1
      this.getJourneyMapList()
    },
    getJourneyMapList() {
      const params = {
        journeyTitle: this.searchForm.journeyTitle || null,
        projectName: this.searchForm.projectName || null,
        createBy: this.searchForm.createBy || null,
        startCreateTime: this.createTimeRange && this.createTimeRange.length > 0 ? this.createTimeRange[0].split(' ')[0] : null,
        endCreateTime: this.createTimeRange && this.createTimeRange.length > 0 ? this.createTimeRange[1].split(' ')[0] : null,
        startUpdateTime: this.updateTimeRange && this.updateTimeRange.length > 0 ? this.updateTimeRange[0].split(' ')[0] : null,
        endUpdateTime: this.updateTimeRange && this.updateTimeRange.length > 0 ? this.updateTimeRange[1].split(' ')[0] : null,
        current: this.page.current,
        size: this.page.size,
      }
      this.$axios.post("/uxm/content/journey-map/page", params).then(res => {
        if (res && res.data && res.data.data) {
          this.tableData = res.data.data.records || []
          this.page.size = res.data.data.size || 10
          this.page.current = res.data.data.current || 1
          this.page.total = res.data.data.total || 0
        } else {
          this.tableData = []
          this.page.total = 0
        }
      }).catch(error => {
        console.error('获取地图列表失败:', error)
        this.tableData = []
        this.page.total = 0
      })
    }
  }
}
</script>

<style scoped>
.el-pagination {
  float: right;
  margin-top: 22px;
}
</style>

